import api from '../lib/axios';

const SinapiService = {
  async searchComposicoes({ query = '', estado = 'SP', grupo = '', page = 1, limit = 20, tipoPreco = 'NAO_DESONERADO' }) {
    const params = new URLSearchParams({ action: 'composicoes', q: query, estado, grupo, page, limit, tipoPreco });
    const { data } = await api.get(`/api/sinapi?${params}`);
    return data;
  },

  async getComposicao(codigo, estado = 'SP', tipoPreco = 'NAO_DESONERADO') {
    const params = new URLSearchParams({ action: 'composicao', codigo, estado, tipoPreco });
    const { data } = await api.get(`/api/sinapi?${params}`);
    return data;
  },

  async searchInsumos({ query = '', estado = 'SP', page = 1, limit = 20, tipoPreco = 'NAO_DESONERADO' }) {
    const params = new URLSearchParams({ action: 'insumos', q: query, estado, page, limit, tipoPreco });
    const { data } = await api.get(`/api/sinapi?${params}`);
    return data;
  },

  async getStatus() {
    const { data } = await api.get('/api/sinapi?action=status');
    return data;
  },

  async getUploadUrl(adminEmail) {
    const { data } = await api.post('/api/admin/sinapi', { action: 'upload-url' });
    return data;
  },

  async uploadToStorage(signedUrl, file) {
    await fetch(signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      body: file,
    });
  },

  async importStep({ mesRef, adminEmail, filePath, step }) {
    const { data } = await api.post('/api/admin/sinapi', {
      mesRef,
      filePath,
      step,
    }, {
      timeout: 120000,
    });
    return data;
  },
};

export default SinapiService;
